import { CAT_NECESSARY, CAT_ANALYTICS } from "../constants.js";

const translation = {
  consentModal: {
    title: "Ogeysiiska Kookiyada",
    description:
      "Waxaan isticmaalnaa kookiyo muhiim ah si aan u hubinno in degelkan si sax ah u shaqeeyo. Waxaan sidoo kale isticmaalnaa kookiyo raadraac ikhtiyaari ah si aan u fahamno sida aad ula falgasho boggayaga. Kookiyadaas ikhtiyaarka ah waxay kaliya la dejin doonaan oggolaanshahaaga.",
    acceptAllBtn: "Dhammaan aqbal",
    acceptNecessaryBtn: "Dhammaan diid",
    showPreferencesBtn: "Maamul doorashooyinka shakhsiga ah",
  },
  preferencesModal: {
    title: "Maamul doorashooyinka kookiyada",
    acceptAllBtn: "Dhammaan aqbal",
    acceptNecessaryBtn: "Dhammaan diid",
    savePreferencesBtn: "Aqbal xulashada hadda",
    closeIconLabel: "Xir daaqadda",
    sections: [
      {
        title: "Isticmaalka kookiyada",
        description:
          "Waxaan isticmaalnaa kookiyo si aan u taageerno shaqooyinka muhiimka ah ee degelkan isla markaana aan kuu wanaajino waayo‑aragnimadaaga.",
      },
      {
        title: "Kookiyo aad muhiim u ah",
        description:
          "Kookiyadan waa muhiim si degelku si sax ah u shaqeeyo, tusaale ahaan sugida aqoonsiga isticmaalaha.",
        linkedCategory: CAT_NECESSARY,
        cookieTable: {
          headers: {
            name: "Magaca",
            domain: "Adeegga",
            description: "Sharaxaad",
            expiration: "Waqtiga dhicitaanka",
          },
          body: [
            {
              name: "_care_leavers_social_hub_session",
              domain: "www.secure-messaging.co.uk",
              description:
                "Kooki uu dejiyay Madasha Bulshada Dijitaalka ah oo loogu talagalay sugida aqoonsiga isticmaalaha.",
              expiration: "Fadhi",
            },
            {
              name: "CSRF-TOKEN",
              domain: "www.secure-messaging.co.uk",
              description:
                "Kooki uu dejiyay Madasha Bulshada Dijitaalka ah oo loogu talagalay sugida aqoonsiga isticmaalaha",
              expiration: "Fadhi",
            },
            {
              name: "__cf_bm",
              domain: ".www.secure-messaging.co.uk",
              description:
                "Kookigan waxaa loo isticmaalaa in lagu kala saaro dadka iyo mashiinnada si loo ilaaliyo degelka ka dhanka ah xadgudubyada otomaatiga ah. Xog shaqsi ah lama ururiyo.",
              expiration: "30 daqiiqo",
            },
          ],
        },
      },
      {
        title: "Falanqayn",
        description:
          "Kookiyada loo adeegsado falanqaynta waxay caawiyaan ururinta xogta oo gacan siiya adeegyada inay fahmaan sida isticmaalayaashu ula falgalaan adeeg gaar ah. Aragtiyahani waxay u saamaxaan horumarinta nuxurka iyo dhisidda astaamo fiican oo wanaajiya waayo‑aragnimada isticmaalaha.",
        linkedCategory: CAT_ANALYTICS,
        cookieTable: {
          headers: {
            name: "Magaca",
            domain: "Adeegga",
            description: "Sharaxaad",
            expiration: "Waqtiga dhicitaanka",
          },
          body: [
            {
              name: "_ga",
              domain: "Google Analytics",
              description:
                'Kooki uu dejiyay <a href="https://business.safety.google/adscookies/">Google Analytics</a>',
              expiration: "Dhacaya 12 maalmood kadib",
            },
            {
              name: "_gid",
              domain: "Google Analytics",
              description:
                'Kooki uu dejiyay <a href="https://business.safety.google/adscookies/">Google Analytics</a>',
              expiration: "Fadhi",
            },
          ],
        },
      },
    ],
  },
};

const servicesLabel =
  "Waxay sahlaysa kaydinta la xidhiidha falanqaynta tusaale. muddada booqashada.";

export { translation, servicesLabel };
